import { makeStyles } from '@material-ui/core'

import { lang } from '../../../../localization'

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 8,
    boxShadow: 'none'
  },
  roomTypeRow: {
    width: '100%',
    boxShadow: 'none'
  },
  avalabilitiesContainer: {
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(15,1fr)'
  },
  avalabilitiesContainerForMonth: {
    gridTemplateColumns: 'repeat(32,1fr)'
  },
  dayContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    height: 70,
    fontSize: 14,
    width: 100,
    color: 'gray',
    borderLeft: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`,
    borderBottom: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`,
    boxSizing: 'border-box',

    '& input': {
      fontSize: 13,
      width: '98%',
      textAlign: 'center',
      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent',
      color: theme.palette.type === 'dark' ? 'white' : 'black'
    }
  },
  priceDayContianer: {
    '& input': {
      fontSize: 10
    }
  },
  weekendDayContainer: {
    backgroundColor:
      theme.palette.type === 'dark' ? `rgba(120, 132, 255,0.25)` : '#fff2f2'
  },
  selectedDayContainer: {
    border: `2px solid ${theme.palette.grey[700]}`,
    borderRadius: 4
  },
  rowName: {
    marginLeft: 8,
    flex: 1,
    display: 'flex',
    alignItems: 'center'
  },
  rowNameTitle: {
    flex: 1,
    marginLeft: 10
  },
  channelName: {
    marginLeft: 28,
    '& h5': {
      color: theme.palette.secondary.dark
    }
  },
  rowNameContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '3%'
  },
  channel: {
    marginLeft: 8,
    cursor: 'pointer'
  },
  roomIcon: {
    width: 30
  },
  channelArrowRight: {
    marginRight: 6,
    fontSize: 14,
    transition: `transform 0.2s`,
    transform: `rotate(${lang === 'fa' ? '180deg' : '0deg'})`
  },
  channelArrowRightCollapsed: {
    transform: `rotate(${lang === 'fa' ? '-90deg' : '90deg'})`
  },
  copyButtonContainer: {
    marginRight: 8
  },
  copyButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    transition: 'all 0.5s linear',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  },
  numberOfRatePlans: {
    color: theme.palette.primary.main,
    cursor: 'pointer'
  }
}))

export default useStyles
